const getRole = () => {
    try {
        return JSON.parse(JSON.parse(localStorage.getItem('admin')).auth).user.authority[0]
    } catch (e) {
        return null
    }
}

const appConfig = {
    apiPrefix: '/api',
    get authenticatedEntryPath() {
        const role = getRole()
        // console.log(role)
        return role === 'admin' ? '/all-locations-view' : '/invite'
    },
    unAuthenticatedEntryPath: '/landing',
    tourPath: '/',
}

export const getAuthenticatedEntryPath = () => {
    try {
        const auth = JSON.parse(JSON.parse(localStorage.getItem('admin')).auth)
        const role = auth.user.authority[0]

        if (role === 'admin') return '/all-locations-view'
        if (role === 'user') return '/invite'
    } catch (e) {
        return '/sign-in'
    }
    return '/sign-in'
}

export default appConfig